import type { AutocompleteProps } from '@mui/material';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { extract, isNotEmptyString, withDefault } from '@vy/utils';
import React from 'react';
import { useEventFields } from '../../../../hooks/requests/use-event-fields';

type MeterFieldSelectProps = Omit<
  AutocompleteProps<string, false, false, true>,
  'options' | 'renderInput'
> & {
  eventName: string | undefined;
  label?: string;
  inputRef?: React.Ref<HTMLInputElement>;
};

export const MeterFieldSelect: React.FC<MeterFieldSelectProps> = ({
  eventName = '',
  label = 'Field',
  inputRef,
  ...props
}) => {
  const { data, isLoading } = useEventFields(eventName, {
    enabled: isNotEmptyString(eventName),
  });

  const eventFields = withDefault(data?.eventFields, []);
  const eventFieldsNames = extract(eventFields, 'name');

  return (
    <Autocomplete
      size="small"
      {...props}
      options={eventFieldsNames}
      loading={isLoading}
      freeSolo
      autoSelect
      renderInput={(params) => (
        <TextField
          label={label}
          placeholder="Select criterion"
          {...params}
          inputRef={inputRef}
          slotProps={{
            ...params.slotProps,

            htmlInput: {
              ...params.slotProps.htmlInput,
              autoComplete: 'new-password',
            },

            inputLabel: { shrink: true }
          }} />
      )}
    />
  );
};
